export const subType = {
  new: "new",
  active: "active",
  pending: "pending",
  not_active: "not active",
};
